import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  UpdateAnnouncementDetails,
  UpdateAnnouncementDetailsSchema,
} from './UpdateAnnouncementDetails';

export const UpdateAnnouncementDetailsExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'UpdateAnnouncementDetails',
    component: UpdateAnnouncementDetails,
    schema: UpdateAnnouncementDetailsSchema,
  }),
);
